import { MFAChannel } from '@/modules/user/components/SignIn/MultiFactorAuthentication/mfa.types';
import { storeCreator } from '@/utils/store/store.utils';

interface State {
  activeChannel?: MFAChannel;
  channels?: MFAChannel[];
  session?: string;
  isRememberMe?: boolean;
  isRequiredExpressSetup?: boolean;
  userName?: string;
  setActiveChannel: (channel: MFAChannel) => void;
  setChannelCodeSentTimestamp: (channel: MFAChannel, timestamp: number) => void;
  setChannels: (channels: MFAChannel[]) => void;
  setSession: (session: string) => void;
  setIsRememberMe: (isRememberMe: boolean) => void;
  setUserName: (userName: string) => void;
  setIsRequiredExpressSetup: (isRequiredExpressSetup?: boolean) => void;
  resetStore: () => void;
}

const useMFAStore = storeCreator<State>((set) => ({
  activeChannel: undefined,
  session: undefined,
  isRememberMe: undefined,
  isRequiredExpressSetup: undefined,
  userName: undefined,
  channels: [],

  setActiveChannel: (channel: MFAChannel) => set((state) => ({
    ...state,
    activeChannel: channel,
  })),

  setChannelCodeSentTimestamp: (channel: MFAChannel, timestamp: number) => set((state) => ({
    channels: state.channels?.map((ch) => ch?.value === channel.value ? { ...ch, codeSentTimestamp: timestamp } : ch),
  })),

  setChannels: (channels: MFAChannel[]) => set((state) => ({
    ...state,
    channels,
  })),

  setSession: (session: string) => set((state) => ({
    ...state,
    session,
  })),

  setIsRememberMe: (isRememberMe: boolean) => set((state) => ({
    ...state,
    isRememberMe,
  })),

  setIsRequiredExpressSetup: (isRequiredExpressSetup?: boolean) => set((state) => ({
    ...state,
    isRequiredExpressSetup,
  })),

  setUserName: (userName: string) => set((state) => ({
    ...state,
    userName,
  })),

  resetStore: () => set((state) => ({
    ...state,
    activeChannel: undefined,
    session: undefined,
    isRememberMe: undefined,
    isRequiredExpressSetup: undefined,
    userName: undefined,
    channels: [],
  })),
}));

export default useMFAStore;
